import QuestionConfig from "./QuestionConfig";
import BasePlayer from "../utils/BasePlayer";
import { Observable } from "rxjs";

export default class QuestionPlayer extends BasePlayer {
  constructor(public config: QuestionConfig) {
    super(config);
  }

  public getQuestionObservable(): Observable<any> | null {
    if (this.content) {
      return this.content.observable;
    }
    return null;
  }
}
